import { Injectable } from '@angular/core';
import { RequestBase } from './request-base';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class DocumentationService extends RequestBase {
    BasePath = 'api/documentation';

    GenerateDocumentation(data): Observable<any> {
        return this.http.post(this.API_BASE_URL + this.BasePath + '/GenerateDocumentation', data, {
            observe: 'response',
            responseType: 'blob'
        });
    }
}